import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Stethoscope, Shield } from 'lucide-react';
import { LanguageToggle } from '@/components/LanguageToggle';

export function DoctorLogin() {
  const { t } = useTranslation();
  const { isLoading, loginWithRedirect } = useAuth0();

  const handleDoctorLogin = () => {
    // Store userType BEFORE redirecting to Auth0
    localStorage.setItem('userType', 'doctor');
    localStorage.setItem('userType_doctor', 'doctor');
    loginWithRedirect({
      authorizationParams: {
        prompt: 'login',
        max_age: 0,
        scope: 'openid profile email',
        redirect_uri: `${globalThis.location.origin}/auth/callback/doctor`
      }
    });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">{t('app.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <LanguageToggle />
      </div>

      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <img src="https://pub-327c49603f8c4373ac8b69237691fafc.r2.dev/rds-logo.png" alt="Logo" className="h-28 w-28" />
          </div>
          <CardTitle className="text-2xl font-bold">
            {t('auth.doctorLogin')}
          </CardTitle>
          <CardDescription>
            {t('auth.doctorLoginDescription')}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
            <div className="flex items-start space-x-3">
              <Shield className="h-5 w-5 text-blue-600 dark:text-blue-400 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-blue-900 dark:text-blue-100">
                  {t('auth.secureLogin')}
                </p>
                <p className="text-blue-700 dark:text-blue-300 mt-1">
                  {t('auth.auth0Info')}
                </p>
              </div>
            </div>
          </div>

          <Button
            onClick={handleDoctorLogin}
            className="w-full"
            size="lg"
          >
            {t('auth.loginAsDoctor')}
          </Button>

          <div className="text-center">
            <button
              onClick={() => {
                // Navigate to parent login
                globalThis.location.href = '/parent/login';
              }}
              className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
            >
              {t('auth.switchToParentPortal')}
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

